import { render, staticRenderFns } from "./CreateRawMenu.vue?vue&type=template&id=ca6cc0a2&"
import script from "./CreateRawMenu.vue?vue&type=script&lang=js&"
export * from "./CreateRawMenu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports